<script>
  import { onMount } from "svelte";
  import Router from "svelte-spa-router";
  import { routes } from "./lib/router.js";
  import { isLoading } from "./lib/stores/auth.svelte.js";
  import { isLoaded } from "./lib/i18n.svelte.js";
  import Layout from "./components/Layout.svelte";
  import Toast from "./components/Toast.svelte";

  let ready = $derived(!isLoading() && isLoaded());
  let path = $state("/");

  function readPath() {
    const hash = window.location.hash.slice(1) || "/";
    return hash.split("?")[0] || "/";
  }

  onMount(() => {
    path = readPath();
    const onHashChange = () => {
      path = readPath();
    };

    window.addEventListener("hashchange", onHashChange);
    return () => window.removeEventListener("hashchange", onHashChange);
  });

  let isLoginRoute = $derived(path === "/" || path === "/login");
</script>

{#if !ready}
  <div class="min-h-screen w-full bg-black flex items-center justify-center">
    <div class="animate-pulse text-zinc-500 text-sm">Loading...</div>
  </div>
{:else if isLoginRoute}
  <Router {routes} />
{:else}
  <Layout>
    <Router {routes} />
  </Layout>
{/if}

<Toast />
